<template>
  <div class="col-md-8 mx-auto mt-3 px-0">
    <label for="signature" class="font-weight-bold">
      Review and sign the contract above:
    </label>
    <canvas ref="signatureCanvas" id="ContractSignature"/>
    <validation-message v-if="validationMessage" :message="validationMessage"/>
    <button @click="clear" class="btn btn-primary mt-2">Clear</button>
  </div>
</template>

<script>
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import SignaturePadLib from 'signature_pad'

export default {
  name: 'SignaturePad',
  props: {
    value: { type: String, default: '' },
    validationMessage: { type: String, default: '' }
  },
  data () {
    return {
      pad: null,
      handleEndStroke: null,
      resizeObserver: null
    }
  },
  methods: {
    clear () {
      this.pad.clear()
      this.$emit('input', '')
    },
    resizeCanvas () {
      const canvas = this.$refs.signatureCanvas
      if (!canvas || !canvas.offsetWidth || !canvas.offsetHeight) {
        return
      }
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      if (this.pad) {
        this.pad.clear()
      }
      this.$emit('input', '')
    }
  },
  mounted () {
    const canvas = this.$refs.signatureCanvas
    this.pad = new SignaturePadLib(canvas)
    this.handleEndStroke = () => {
      this.$emit('input', this.pad.toDataURL())
    }
    this.pad.addEventListener('endStroke', this.handleEndStroke)
    this.resizeCanvas()
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resizeCanvas())
      this.resizeObserver.observe(canvas)
    } else {
      window.addEventListener('resize', this.resizeCanvas)
    }
  },
  beforeDestroy () {
    if (this.pad && this.handleEndStroke) {
      this.pad.removeEventListener('endStroke', this.handleEndStroke)
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.resizeCanvas)
    }
  },
  components: {
    'validation-message': ValidationMessage
  }
}
</script>

<style scoped>
#ContractSignature {
  background: #FFEDB2;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 12rem;
  width: 100%;
}
@media screen and (max-width: 768px) {
  #ContractSignature {
    height: 10rem;
    width: 100%;
  }
}
</style>
